import * as React from 'react'
import styled from '../theme/styled'

import { StyledComponentClass } from 'styled-components'

export interface IButtonProps {
  children?: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
  className?: string
  color?: string
  fontColor?: string
  fontColorHover?: string
  disabled?: boolean
  size?: string
  width?: string
  margin?: string
}

export interface IButtonInternalProps extends IButtonProps {
  color: string
  altColor: string
  fontColor: string
  fontColorHover: string
  size: string
}

const defaultProps = {
  color: 'primaryDark',
  altColor: 'primaryDark',
  fontColor: 'white',
  fontColorHover: 'textLight',
  size: 'medium'
}

export const KeravaRadarButton: React.SFC<IButtonProps> = ({ children, ...props }) =>
  <DefaultButton {...defaultProps} {...props}>
    {children}
  </DefaultButton>

const BaseButton: StyledComponentClass<IButtonInternalProps, any> = styled<IButtonInternalProps, 'button'>('button')`
  border: ${({ color, theme }) => `0.1em solid ${theme.color[color]}`};
  border-radius: 0.12em;
  box-sizing: border-box;
  color: ${({ theme, fontColor }) => theme.color[fontColor]};
  cursor:  pointer;
  display: inline-block;
  font-family: "Gotham A","Gotham B",Sans-serif;
  font-size: ${({ theme, size }) => theme.button.sizes[size].fontSize};
  height: ${({ theme, size }) => theme.button.sizes[size].height};
  outline: none;
  opacity: ${({ disabled }) => disabled ? 0.4 : 1};
  padding: ${({ theme, size }) => theme.button.sizes[size].padding};
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  will-change: box-shadow, transform;
  transition: all 0.2s;
  width: ${({ width }) => width};
  overflow: hidden;

  &:hover {
    color: ${({ theme, fontColorHover }) =>
    theme.color[fontColorHover]};
    background-color: ${({ altColor, theme }) =>
    theme.color[altColor]};
  }

  &:after {
    content: "";
    background: ${({ theme }) => theme.color['textLight']};
    display: block;
    position: absolute;
    padding-top: 300%;
    padding-left: 350%;
    margin-left: -20px!important;
    margin-top: -120%;
    opacity: 0;
    transition: all 0.8s
}

&:active:after {
    padding: 0;
    margin: 0;
    opacity: 1;
    transition: 0s
}
`

const DefaultButton: StyledComponentClass<IButtonInternalProps, any> = BaseButton.extend`
  background-color: ${({ color, theme }) => theme.color[color]}
`



// WEBPACK FOOTER //
// ./src/elements/button.tsx